import { createSelector } from 'reselect';

const selectorLoginForm = state => state.form.loginForm.values;

// SELECTOR REDUX FORM
export const usernameSelector = () =>
  createSelector(selectorLoginForm, state => state.username);
export const passwordSelector = () =>
  createSelector(selectorLoginForm, state => state.password);
